<template>
  <svg class="eye-icon" width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.41246 0.00195312L19.3813 16.9708L19.3831 16.969L19.3848 16.9708L17.9706 18.385L14.6137 15.0281C13.3568 15.6144 11.8332 16.0002 10 16.0002C2.408 16.0002 0.126318 9.3832 0.104436 9.3162L0 9.0002L0.105431 8.6842C0.118626 8.64187 1.03404 5.98562 3.62047 4.03488L1 1.41441L2.41246 0.00195312ZM13.0867 13.5011L11.2895 11.7039C10.8976 11.8936 10.4599 12.0002 10 12.0002C8.358 12.0002 7 10.6422 7 9.0002C7 8.54033 7.10665 8.1026 7.29631 7.71072L5.03632 5.45073C3.26898 6.66613 2.41537 8.30996 2.11657 9.0002C2.61587 10.1542 4.67774 14.0002 10 14.0002C11.184 14.0002 12.2067 13.8098 13.0867 13.5011Z" :fill="fill"/>
    <path d="M7.50022 2.26128C8.26109 2.09472 9.09262 2.0002 10 2.0002C17.592 2.0002 19.8737 8.6172 19.8956 8.6842L20 9.0002L19.8946 9.3162C19.8843 9.34922 19.3248 10.9733 17.8511 12.6121L16.4594 11.2205C17.2458 10.3298 17.6859 9.45657 17.8834 9.0002C17.3841 7.8462 15.3223 4.0002 10 4.0002C9.74753 4.0002 9.50239 4.00886 9.2644 4.02547L7.50022 2.26128Z" :fill="fill"/>
  </svg>
</template>

<script>
export default {
  name: 'EyeIcon',
  props: {
    fill: {
      type: String,
      default: '#A217AB'
    }
  }
}
</script>

<style lang="scss" scoped>
.eye-icon {
  &--outlined{
    & > .sclera {
      stroke: black;
      stroke-width: 2px;
    }
  }
}
</style>
